export default __webpack_public_path__ + "static/media/banner2.a1e93e7a.jpg";